/* global mo */

$(function(){
	// активные типы уведомлений
	var types = {};
	var el_html = indicators.get_html();

	$.map(mo.user.indicators, function(key_on, key){
		key = key.split(':');
		var type = key[0];
		var id = key[1];

		// вставить индикаторы
		if(type == 'order'){
			// console.log(tab_id);
			// types[type] = 1;
            //
			// var $order = $('#orders [data-order_id='+id+']');
			// if(!$order.length) return;
            //
			// $('td', $order).eq(0).append(el_html);
            //
			// var tab_id = $order.closest('.tab').attr('id').replace('tab_', '');
			// $('#orders a[href="#'+tab_id+'"]').css({position:'relative'}).append(el_html);
		}

		if(type == 'my_comments'){
			// types[type] = 1;
            //
			// var $base_for_comment = $('#my_comments [data-id='+id+']');
			// if(!$base_for_comment.length) return;
            //
			// $base_for_comment.append(el_html);
		}
	});

	// вставить типовые индикаторы)
	// $.map(types, function(type_on, type){
	// 	switch(type){
	// 		case 'order':
	// 			// if(!$('#sidemenu').length) $('#top_panel .user').append(el_html);
	// 			// $('[id=profile_menu] a[href="/account/#to_orders"]').css({position:'relative'}).append(el_html);
	// 			$('#sidemenu a[href="#to_orders"] .wrap').css({position:'relative'}).append(el_html);
    //
	// 			break;
    //
	// 		case 'my_comments':
	// 			// if(!$('#sidemenu').length) $('#top_panel .user').append(el_html);
	// 			// $('[id=profile_menu] a[href="/account/#to_my_comments"]').css({position:'relative'}).append(el_html);
	// 			$('#sidemenu a[href="#to_my_comments"] .wrap').css({position:'relative'}).append(el_html);
    //
	// 			break;
	// 	}
	// });

	// удаление индикатора заказа
	// $('#orders .el').hover(function(){
	// 	var order_id = $(this).data('order_id');
    //
	// 	var $indicator = $('.indicator:not(.removed)', this);
	// 	if(!$indicator.length) return;
    //
	// 	$indicator.addClass('removed', {duration: 500});
	// 	mo.get('', 'user', 'set_alert_indicator', {type:'order', id:order_id, on:0});
	// });
});

var indicators = {};
indicators.get_html = function(){
	return '<div class="indicator"><span class="icon-lamp_on"></span></div>';
};